import { JpgFileIcon, PdfFileIcon, PngFileIcon, TxtFileIcon } from "icons";

export const FILE_EXTENSION_ICONS = {
  pdf: PdfFileIcon,
  png: PngFileIcon,
  txt: TxtFileIcon,
  jpg: JpgFileIcon,
};
